import { useMemo } from 'react';

import { useAppSelector } from '@/redux';
import { useFeature } from './useFeature';
import { FEATURES } from '@/constants/features';

export const useDisplayMyCellar = () => {
  const storeConf = useAppSelector(({ root }) => root?.storeConf);
  const actAsCustomer = useAppSelector(({ admin }) => admin?.actAsCustomer);
  const userHasStorage = useAppSelector(({ user }) => user?.content?.hasStorage);
  const isMyCellarFeatureEnabled = useFeature(storeConf, FEATURES.MODULE_MY_CELLAR);

  const displayMyCellar = useMemo(() => {
    return (isMyCellarFeatureEnabled || actAsCustomer) && userHasStorage;
  }, [actAsCustomer, isMyCellarFeatureEnabled, userHasStorage]);

  return displayMyCellar;
};
